import { link } from "@authentic/loyalty-pwa/util";
import { h, FunctionalComponent, Fragment } from "preact";
import { SwiperSlide } from "swiper/react";
import { Carousel } from "../../../components/Carousel";
import { ProcessStep, ProcessStepProps } from "../../../components/process-step/process-step";
import { TierInfo, TierInfoProps } from "../../../components/tier-info/tier-info";
import { DelYeahContainer } from "../../../containers/DelYeahContainer";
import { AboutProgramFooter, AboutProgramStyled, StatusOveriewContentStyled, StepsContentStyled, TierPointsContentStyled } from "./about-program.style";
import { stepProcessList } from "./step-process-list";
import { tierList } from "./tier-list";

export const DelYeahAboutProgram: FunctionalComponent = () => {
  const htmlTitle: string = 'About Del Yeah! Rewards';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '8';
  return (
    <Fragment>
      <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
        <AboutProgramStyled bgColor={'#F2F2F2'}>
          <h2>How it works</h2>

          <StepsContentStyled>
            {stepProcessList?.map((item: ProcessStepProps) => (
              <ProcessStep
                title={item.title}
                subtitle={item.subtitle}
                description={item.description}
                image={item.image}>
              </ProcessStep>
            ))}
          </StepsContentStyled>
        </AboutProgramStyled>
        <StatusOveriewContentStyled>
          <AboutProgramStyled bgColor={'white'}>
            <h2>Status overview</h2>
            <p>Level up to increase your earnings!</p>

            <TierPointsContentStyled>
              <Carousel indexCarouselRef={2} spaceBetween={20} breakpoints={{ slidesPerViewLg: 4, slidesPerViewMd: 3, slidesPerViewSm: 1 }}>
                {tierList?.map((item: TierInfoProps) => (
                  <SwiperSlide>
                    <TierInfo
                      tierPoints={item.tierPoints}
                      detail={item.detail}></TierInfo>
                  </SwiperSlide>
                ))}
              </Carousel>
            </TierPointsContentStyled>
          </AboutProgramStyled>
        </StatusOveriewContentStyled>

        <AboutProgramFooter>
          <a href={link('/your-rewards')}>My Rewards & Offers</a>
        </AboutProgramFooter>
      </DelYeahContainer>
    </Fragment>
  )
}